// extracted by mini-css-extract-plugin
export var card = "index-module--card--1bLDs";
export var body = "index-module--body--_HWjB";
export var title = "index-module--title--3m5Um";
export var secondaryCard = "index-module--secondaryCard--2r7HK";